module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel06_1280_1280_en-f9f043222fe35f88b3913d163b3c77ab.jpg";